import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";
import {
  PassportActionType,
  PassportRuleType,
  ProtocolToDefaultPort,
} from "#src/services/endpoint/passports/enums";
import i18next from "i18next";

const fixedTFunc = i18next.getFixedT(null, "endpoint", "passports.filters");

export const passportTypeFilterItems: IFilterItemV2[] = [
  {
    key: PassportRuleType.HOST_HOST,
    value: PassportRuleType.HOST_HOST,
    getLabel: () => fixedTFunc("type.hostToHost"),
  },
  {
    key: PassportRuleType.USER_HOST,
    value: PassportRuleType.USER_HOST,
    getLabel: () => fixedTFunc("type.userToHost"),
  },
];

export const passportActionFilterItems: IFilterItemV2[] = [
  {
    key: PassportActionType.ACCEPT,
    value: PassportActionType.ACCEPT,
    getLabel: () => fixedTFunc("action.accept"),
  },
  {
    key: PassportActionType.REJECT,
    value: PassportActionType.REJECT,
    getLabel: () => fixedTFunc("action.reject"),
  },
];

export const passportPortFilterItems: IFilterItemV2[] = Object.entries(
  ProtocolToDefaultPort
).map(([protocol, port]) => ({
  key: port,
  value: port,
  getLabel: () =>
    !protocol ? fixedTFunc("port.other") : `${protocol} (${port})`,
}));

export const passportStatusFilterItems: IFilterItemV2[] = [
  {
    key: "true",
    value: "1",
    getLabel: () => fixedTFunc("status.enabled"),
  },
  {
    key: "false",
    value: "0",
    getLabel: () => fixedTFunc("status.disabled"),
  },
];
